module.exports = "/assets/data/d066ae7a4070ee6766f5925ea4d70854-BB2.data.json";